import { render, staticRenderFns } from "./kyc_docs_upload.vue?vue&type=template&id=76cb0ead"
import script from "./kyc_docs_upload.vue?vue&type=script&lang=js"
export * from "./kyc_docs_upload.vue?vue&type=script&lang=js"
import style0 from "./kyc_docs_upload.vue?vue&type=style&index=0&id=76cb0ead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports